let cachedEnabled = null;
let cachedLimitHour = null;
let cachedMaxReportDurationHour = null;
let inflight = null;

export function resetLimitOvertimeReportCache() {
  cachedEnabled = null;
  cachedLimitHour = null;
  cachedMaxReportDurationHour = null;
  inflight = null;
}

/**
 * 是否启用限制超时报工（type 78 + limitHour + maxReportDurationHour）；结果按会话缓存。
 */
export function fetchLimitOvertimeReportEnabled(http) {
  if (cachedEnabled !== null) {
    return Promise.resolve(cachedEnabled);
  }
  if (inflight) {
    return inflight;
  }
  inflight = http
    .get('/web/production/config/limitOvertimeReportEnabled')
    .then(res => {
      const payload = res && res.data;
      cachedLimitHour = payload && payload.limitHour;
      cachedMaxReportDurationHour = payload && payload.maxReportDurationHour;
      cachedEnabled = !!(payload && payload.limitOvertimeReportEnabled);
      inflight = null;
      return cachedEnabled;
    })
    .catch(() => {
      inflight = null;
      cachedEnabled = false;
      return false;
    });
  return inflight;
}

export function getMaxReportDurationHour() {
  return cachedMaxReportDurationHour;
}

export function manualDatetimeToMs(str) {
  if (str == null || str === '') {
    return null;
  }
  if (typeof str === 'number' && !isNaN(str)) {
    return str;
  }
  const t = Date.parse(String(str).replace(/-/g, '/'));
  return isNaN(t) ? null : t;
}

function truncateToMinute(epochMs) {
  return epochMs - (epochMs % 60000);
}

/**
 * 校验报工时长是否在配置上限内；超出则提示并返回 false。
 */
export function assertReportDurationWithinLimit(startMs, endMs, vm) {
  if (cachedMaxReportDurationHour == null || cachedMaxReportDurationHour < 1) {
    return true;
  }
  if (startMs == null || endMs == null) {
    return true;
  }
  const startTrunc = truncateToMinute(startMs);
  const endTrunc = truncateToMinute(endMs);
  const durationMs = endTrunc - startTrunc;
  const maxMs = cachedMaxReportDurationHour * 3600000;
  if (durationMs > maxMs) {
    const msg = vm && vm.$t ? vm.$t('gongshichaoexianjinzhitijiaobaogong') : '工时超限，禁止提交报工';
    if (vm && vm.$message) {
      vm.$message.warning(msg);
    }
    return false;
  }
  return true;
}
